import { ENTITY_PIXELS, GATE_LAYOUT } from '../../config';

/** Lane positions for spawning entities */
export type Lane = 'left' | 'center' | 'right';

/** Four-lane runtime positions for procedural enemy spawns */
export type EnemyLane4 = 'farLeft' | 'leftCenter' | 'rightCenter' | 'farRight';

/** Gate lane positions (gates only spawn left or right for choices) */
export type GateLane = 'left' | 'right';

/**
 * Get X position for a lane
 */
export function getLaneX(lane: Lane, trackWidth: number = 335, trackPadding: number = 20): number {
  const laneWidth = trackWidth / 3;
  const baseX = trackPadding;

  switch (lane) {
    case 'left':
      return baseX + laneWidth * 0.5;
    case 'center':
      return baseX + laneWidth * 1.5;
    case 'right':
      return baseX + laneWidth * 2.5;
  }
}

/**
 * Get X position for four-lane enemy runtime (procedural path)
 */
export function getEnemyLane4X(
  lane: EnemyLane4,
  trackWidth: number = 335,
  trackPadding: number = 20
): number {
  const normalizedByLane: Record<EnemyLane4, number> = {
    farLeft: 0.14,
    leftCenter: 0.37,
    rightCenter: 0.63,
    farRight: 0.86,
  };
  return trackPadding + trackWidth * normalizedByLane[lane];
}

/**
 * Get X position for gate lanes (left/right only)
 */
export function getGateLaneX(lane: GateLane, trackWidth: number = 335, trackPadding: number = 20): number {
  const centerX = trackPadding + trackWidth / 2;
  const halfGateStride = ENTITY_PIXELS.gateWidth / 2 + GATE_LAYOUT.horizontalGapPx / 2;

  if (lane === 'left') {
    return centerX - halfGateStride;
  } else {
    return centerX + halfGateStride;
  }
}
